module.exports = __webpack_public_path__ + "img/trash.c7bb75d7.svg";